import _extends from "@babel/runtime/helpers/extends";
import React from 'react';
import { SvgIcon, SvgFill } from '@chegg-ui/svg-icon';
var SellBooks = /*#__PURE__*/React.forwardRef(function (props, ref) {
  return /*#__PURE__*/React.createElement(SvgIcon, _extends({}, props, {
    ref: ref
  }), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement(SvgFill, {
    d: "m38.441 7.52-5.098-4.9c-1.1-1.4-2.9-2.2-4.799-2.2H10.149c-3.6 0-6.499 2.9-6.499 6.5v27.2c0 1.5.6 2.7 1.6 3.7 1.2 1.1 5.199 5.1 5.199 5.1 1 1 2.3 1.5 3.599 1.5h21.194c2.8 0 5.099-2.3 5.099-5.1v-27.2c.1-1.7-.6-3.4-1.9-4.6Zm-31.891 29c-.7-.6-1.1-1.5-1.1-2.4V6.92c0-2.6 2.1-4.7 4.699-4.7h7.498v7.8c0 .4.2.7.5.8.3.1.7.1 1-.2l3.599-3.6 3.599 3.6c.2.2.4.3.6.3.5 0 .9-.4.9-.9v-7.8c2.799-.3 5.398 1.8 5.398 4.7v27.2c0 1.8-1.5 3.3-3.3 3.3H8.75c-.8 0-1.6-.4-2.2-.9Zm32.091 2.8c0 1.8-1.5 3.3-3.299 3.3H14.148c-.9 0-1.7-.4-2.4-1l-2.499-2.5h20.695c2.799 0 5.098-2.3 5.098-5.1 0-.4.1-27 0-27.4 1.5 1.5 3.7 3.1 3.6 5.5v27.2Z"
  }), /*#__PURE__*/React.createElement(SvgFill, {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M23.745 24.72c-.7-1.3-2.1-1.8-3.499-2.1v-4.9c1.1.3 2.2 1.1 2.1 2.3 0 .5.4.9.9.9s.9-.4.9-.9c0-2.3-1.9-3.7-3.9-4.1v-.9c0-.5-.4-.9-.9-.9s-.9.4-.9.9v.9c-5.198.9-5.298 7.3 0 8.1v4.9c-1.3-.3-2.099-1.3-2.099-2.3 0-1.2-1.8-1.2-1.8 0 0 2.1 1.8 3.7 3.9 4.1v.9c0 .5.4.9.9.9s.9-.4.9-.9v-.9c2.898-.4 4.898-3.5 3.498-6Zm-5.298-2.6c-2.8-.4-2.8-3.7 0-4.4v4.4Zm1.8 6.8v-4.5c2.898.4 2.898 3.7 0 4.5Z"
  })));
});
SellBooks.displayName = 'SellBooks';
SellBooks.defaultProps = {
  'aria-label': 'SellBooks'
};
export default SellBooks;


//////////////////
// WEBPACK FOOTER
// ./node_modules/@chegg/writing-checkout/node_modules/@chegg-ui/horizon-icons/dist/esm/icons/Web/SellBooks.js
// module id = 3907
// module chunks = 11